interface IIcon {
  width?: string;
  color?: string;
  height?: string;
}
const QuesCircleFileIcon = ({ width = '16', color = '#AAAAAA', height = '16' }: IIcon) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_528_8813)">
      <path
        d="M4.75 7.5625C2.42378 7.5625 0.53125 9.45503 0.53125 11.7812C0.53125 14.1075 2.42378 16 4.75 16C7.07622 16 8.96875 14.1075 8.96875 11.7812C8.96875 9.45503 7.07622 7.5625 4.75 7.5625ZM4.75 14.2812C4.49113 14.2812 4.28125 14.0714 4.28125 13.8125C4.28125 13.5536 4.49113 13.3438 4.75 13.3438C5.00887 13.3438 5.21875 13.5536 5.21875 13.8125C5.21875 14.0714 5.00887 14.2812 4.75 14.2812ZM5.35497 11.9572C5.27094 11.9973 5.21875 12.0781 5.21875 12.168V12.25C5.21875 12.5089 5.00887 12.7188 4.75 12.7188C4.49113 12.7188 4.28125 12.5089 4.28125 12.25V12.168C4.28125 11.7201 4.54428 11.3052 4.95134 11.1111C5.11184 11.0345 5.25431 10.8463 5.21084 10.5987C5.17869 10.4153 5.02225 10.2588 4.83891 10.2267C4.69534 10.2015 4.55694 10.2376 4.44894 10.3282C4.34237 10.4177 4.28125 10.5487 4.28125 10.6875C4.28125 10.9464 4.07137 11.1562 3.8125 11.1562C3.55363 11.1562 3.34375 10.9464 3.34375 10.6875C3.34375 10.271 3.52681 9.87831 3.84603 9.61025C4.16512 9.34234 4.58597 9.23038 5.00097 9.30325C5.56859 9.40288 6.03463 9.86891 6.13425 10.4366C6.24553 11.0707 5.93237 11.6818 5.35497 11.9572Z"
        fill={color}
        fillOpacity="0.5"
      />
      <path
        d="M13.3438 0.274414V3.12495H16.1941L13.3438 0.274414Z"
        fill={color}
        fillOpacity="0.5"
      />
      <path
        d="M12.875 4.0625C12.6161 4.0625 12.4062 3.85262 12.4062 3.59375V0H5.6875C4.91209 0 4.28125 0.630844 4.28125 1.40625V6.64653C4.43569 6.63253 4.59197 6.625 4.75 6.625C6.34775 6.625 7.77803 7.3555 8.72456 8.5H13.8125C14.0714 8.5 14.2812 8.70988 14.2812 8.96875C14.2812 9.22762 14.0714 9.4375 13.8125 9.4375H9.34212C9.63513 10.0092 9.82406 10.6427 9.88472 11.3125H13.8125C14.0714 11.3125 14.2812 11.5224 14.2812 11.7812C14.2812 12.0401 14.0714 12.25 13.8125 12.25H9.88491C9.74472 13.7981 8.91744 15.1508 7.71119 16H15.0625C15.8379 16 16.4688 15.3692 16.4688 14.5938V4.0625H12.875ZM13.8125 6.625H6.9375C6.67863 6.625 6.46875 6.41512 6.46875 6.15625C6.46875 5.89738 6.67863 5.6875 6.9375 5.6875H13.8125C14.0714 5.6875 14.2812 5.89738 14.2812 6.15625C14.2812 6.41512 14.0714 6.625 13.8125 6.625Z"
        fill={color}
        fillOpacity="0.5"
      />
    </g>
    <defs>
      <clipPath id="clip0_528_8813">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default QuesCircleFileIcon;
